import React, { createContext, useEffect } from 'react';
import { Environment } from 'types';
import { register } from 'utils/tracking';
import useLocalStorage from 'utils/useLocalStorage';

interface EnvironmentProviderProps {
  children: React.ReactNode;
}

interface State {
  environment: Environment;
  setEnvironment: (value: Environment) => void;
  initialRoute: string;
}

const environmentStorageKey = '__environment__';

const EnvironmentContext = createContext<State | undefined>(undefined);

export function EnvironmentProvider(props: EnvironmentProviderProps) {
  const [environment, setEnvironment] = useLocalStorage<Environment>(
    environmentStorageKey,
    'live'
  );

  const initialRoute = environment === 'pre-live' ? '/getting-started' : '/';

  useEffect(() => {
    register({ environment });
  }, [environment]);

  return (
    <EnvironmentContext.Provider
      value={{ environment, setEnvironment, initialRoute }}
      {...props}
    />
  );
}

export function useEnvironment() {
  const context = React.useContext(EnvironmentContext);
  if (context === undefined) {
    throw new Error(`useEnvironment must be used within a EnvironmentProvider`);
  }
  return context;
}
